import Cookies from "js-cookie";
import { toNumber } from "lodash";

import { canUseDOM, isIframeEnvironment } from "~/utils/misc";

if (canUseDOM()) {
  Cookies.defaults = {
    expires: 365 * 10
  };

  // HOTFIX: To fix cookies not working on iPhones
  window.sessionCookies = {}
}

export function getCookie(name, defaultValue = null, isJSON = false) {
  // Return correct value if client
  if (canUseDOM()) {
    // Set default value if not set
    if (is.not.undefined(defaultValue) && is.undefined(Cookies.get(name)) && is.undefined(window.sessionCookies[name])) {
      Cookies.set(name, defaultValue, Object.assign({}, Cookies.defaults, isIframeEnvironment() && global.parser.getBrowser().name != "Safari" ? { SameSite: 'None', Secure: true } : {}));
      window.sessionCookies[name] = defaultValue;
    }

    // Return cookie value
    if (isJSON) {
      if (is.undefined(Cookies.get(name))) JSON.parse(window.sessionCookies[name])
      return Cookies.getJSON(name);
    }

    // Get correct value
    let value = Cookies.get(name);

    if (is.undefined(value)) {
      value = window.sessionCookies[name]
      if (value == "true") value = true
      if (value == "false") value = false
    }

    // Change to number if necessary
    if (/^\d*(\.\d+)?$/.test(value)) {
      value = toNumber(value);
    }

    // Change to boolean if necessary
    if (is.equal(value, "true") || is.equal(value, "false")) {
      value = is.equal(value, "true");
    }

    if (value === null || value === undefined) value = defaultValue

    // return value
    return value;
  }

  // Return value
  return defaultValue;
}

export function saveCookie(name, value, options) {
  // Return correct value if client
  if (canUseDOM()) {
    // Set value
    if (typeof value === 'object') {
      Cookies.set(name, `${JSON.stringify(value)}`, Object.assign({}, Cookies.defaults, isIframeEnvironment() && global.parser.getBrowser().name != "Safari" ? { SameSite: 'None', Secure: true } : {}, options));
      window.sessionCookies[name] = `${JSON.stringify(value)}`;
    } else {
      Cookies.set(name, `${value}`, Object.assign({}, Cookies.defaults, isIframeEnvironment() && global.parser.getBrowser().name != "Safari" ? { SameSite: 'None', Secure: true } : {}, options));
      window.sessionCookies[name] = `${value}`;
    }
  }

  // Return value
  return value;
}

export function removeCookie(name) {
  // Return correct value if client
  if (canUseDOM()) {
    // Set value
    Cookies.remove(name);
  }
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js